import { Component, OnChanges, SimpleChanges, WritableSignal, inject, signal, input, output, model, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, map } from 'rxjs';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'turn-selector',
  templateUrl: './turn-selector.component.html',
  styleUrl: './turn-selector.component.css',
  standalone: false
})
export class TurnSelectorComponent {
  public session = inject(SessionService);
  readonly firstTurn = model<number>(1);
  readonly campaignTurn = input<number>(1);
  readonly onTurnChange = output<number>();

  editTurn: WritableSignal<number> = signal(this.session.turnEdit());
  minTurn = computed(() => Math.min(this.firstTurn(), this.campaignTurn() - 6));
  maxTurn = computed(() => Math.max(this.firstTurn(), this.campaignTurn() + 6));

  constructor () {
  };

  prevMonth() {
    this.editTurn.update(turn => turn - 1);
    this.onTurnChange.emit(this.editTurn());
  };

  nextMonth() {
    this.editTurn.update(turn => turn + 1);
    this.onTurnChange.emit(this.editTurn());
  };
};
